<div class="user-completed-tasks-container" *ngIf="
    projectId &&
    (totalCount > 0 ||
      tasks.length > 0 ||
      (searchTerm && searchTerm.trim() !== ''))
  ">
  <div class="header-section" [class.is-collapsible]="collapsible" [class.is-collapsed]="isCollapsed">
    <h3 class="section-title" (click)="toggleCollapsed()">
      <!-- Open/close arrow: only where collapsible is on (Tasks List page). -->
      <button type="button" class="collapse-arrow" *ngIf="collapsible" [attr.aria-expanded]="!isCollapsed"
        [attr.aria-label]="isCollapsed ? 'Show completed tasks' : 'Hide completed tasks'">
        <i class="pi pi-chevron-down"></i>
      </button>
      <i class="pi pi-check-circle me-2"></i>
      Completed Tasks
      <span class="badge-count ms-2">{{ totalCount }}</span>
    </h3>
    <!-- <div class="completed-search-box" *ngIf="tasks.length > 0 || searchTerm"> -->
    <div class="completed-search-box" *ngIf="(tasks.length > 0 || searchTerm) && !isCollapsed">
      <i class="ri-search-line"></i>
      <input type="text" placeholder="Search completed tasks..." [value]="searchTerm" (input)="onSearch($event)" />
    </div>
    <div class="collapse-actions" *ngIf="collapsible">
      <span class="collapse-hint" *ngIf="isCollapsed">{{ totalCount }} completed {{ totalCount === 1 ? 'task' : 'tasks' }} hidden</span>
      <button type="button" class="collapse-btn" [class.is-show]="isCollapsed" (click)="toggleCollapsed()">
        <i class="pi" [ngClass]="isCollapsed ? 'pi-chevron-down' : 'pi-chevron-up'"></i>
        {{ isCollapsed ? 'Show' : 'Hide' }}
      </button>
    </div>
  </div>

  <!-- Closed: the header bar only (collapsible, Tasks List page). -->
  <ng-container *ngIf="!isCollapsed">
  <!-- Empty search result -->
  <div *ngIf="tasks.length === 0 && !loading && searchTerm" class="empty-state-standalone">
    <div class="empty-icon-wrapper">
      <i class="pi pi-search"></i>
    </div>
    <h5>No results for "{{ searchTerm }}"</h5>
    <p class="text-muted">Try a different search term.</p>
  </div>

  <div class="table-card" *ngIf="tasks.length > 0 || loading">
    <div class="table-responsive task-scroll-container" (scroll)="onScroll($event)">
      <table class="table custom-table align-middle mb-0">
        <thead class="sticky-top">
          <tr>
            <th scope="col" style="width: 30%">Task Name</th>
            <th scope="col" style="width: 10%">Status</th>
            <th scope="col" style="width: 10%">Priority</th>
            <th scope="col" style="width: 12%">Task Group</th>
            <th scope="col" style="width: 13%">Progress</th>
            <th scope="col" style="width: 15%">Assignee</th>
            <th scope="col" style="width: 10%">Completed</th>
          </tr>
        </thead>
        <tbody>
          <!-- Skeleton Loader for Initial Load -->
          <ng-container *ngIf="loading && tasks.length === 0">
            <tr *ngFor="let i of [1, 2, 3, 4, 5]" class="skeleton-row">
              <td>
                <div class="d-flex align-items-center">
                  <p-skeleton shape="circle" size="32px" styleClass="me-3"></p-skeleton>
                  <div class="w-100">
                    <p-skeleton width="60%" height="1rem" styleClass="mb-1"></p-skeleton>
                    <p-skeleton width="40%" height="0.8rem"></p-skeleton>
                  </div>
                </div>
              </td>
              <td>
                <p-skeleton width="80px" height="26px" borderRadius="16px"></p-skeleton>
              </td>
              <td>
                <p-skeleton width="60px" height="26px" borderRadius="16px"></p-skeleton>
              </td>
              <td>
                <p-skeleton width="80px" height="22px" borderRadius="30px"></p-skeleton>
              </td>
              <td><p-skeleton width="100%" height="6px"></p-skeleton></td>
              <td>
                <div class="d-flex">
                  <p-skeleton shape="circle" size="30px" styleClass="me-1"></p-skeleton>
                  <p-skeleton shape="circle" size="30px" styleClass="me-1"></p-skeleton>
                </div>
              </td>
              <td><p-skeleton width="80px" height="1rem"></p-skeleton></td>
            </tr>
          </ng-container>

          <ng-container *ngFor="let task of tasks">
            <tr class="task-row parent-row">
              <!-- Task Name & Completion Toggle -->
              <td>
                <div class="d-flex">
                  <!-- Expand/Collapse Icon -->
                  <button class="btn-expand me-2" *ngIf="task.subTaskCount > 0" (click)="toggleSubtasks(task)">
                    <i class="pi" [ngClass]="
                        expandedTaskId === task._id
                          ? 'pi-chevron-down'
                          : 'pi-chevron-right'
                      "></i>
                  </button>
                  <!-- Placeholder for alignment if no subtasks -->
                  <!-- <span *ngIf="!task.subTaskCount" class="spacer-icon"></span> -->

                  <div class="task-info-group">
                    <div class="d-flex align-items-center">
                      <span class="completion-checkbox completed me-2" (click)="toggleCompletion(task, $event)"
                        [pTooltip]="
                          'Completed by ' +
                          (task.completedBy?.userId?.firstName ||
                            task.completedBy?.userName ||
                            'User') +
                          ' - Click to unmark'
                        " tooltipPosition="top" appendTo="body">
                        <i class="pi pi-check"></i>
                      </span>
                      <span class="task-title text-decoration-line-through text-muted" [pTooltip]="taskTooltip"
                        tooltipPosition="top" [escape]="false" tooltipStyleClass="custom-task-tooltip" appendTo="body">
                        {{ task.title }}
                      </span>
                    </div>
                    <small *ngIf="task.subTaskCount > 0" class="text-muted subtask-count">
                      <i class="pi pi-sitemap text-xs me-1"></i>{{ task.subTaskCount }} subtasks
                    </small>
                  </div>

                  <ng-template #taskTooltip>
                    <div class="task-tooltip-container">
                      <div class="tooltip-header">
                        <i class="pi pi-check-circle me-2"></i> Task Completed
                      </div>
                      <div class="tooltip-body">
                        <div class="tooltip-row">
                          <div class="tooltip-icon">
                            <i class="pi pi-plus-circle"></i>
                          </div>
                          <div class="tooltip-info">
                            <span class="label">Created By</span>
                            <span class="value">{{
                              task.createdBy?.firstName ||
                              task.createdBy?.userName ||
                              "System"
                              }}
                              {{ task.createdBy?.lastName || "" }}</span>
                          </div>
                        </div>
                        <div class="tooltip-row">
                          <div class="tooltip-icon">
                            <i class="pi pi-user"></i>
                          </div>
                          <div class="tooltip-info">
                            <span class="label">Completed By</span>
                            <span class="value">{{
                              task.completedBy?.userId?.firstName ||
                              task.completedBy?.userName ||
                              "User"
                              }}
                              {{
                              task.completedBy?.userId?.lastName || ""
                              }}</span>
                          </div>
                        </div>
                        <div class="tooltip-row">
                          <div class="tooltip-icon">
                            <i class="pi pi-calendar"></i>
                          </div>
                          <div class="tooltip-info">
                            <span class="label">Date</span>
                            <span class="value">{{
                              task.completedAt | date: "mediumDate"
                              }}</span>
                          </div>
                        </div>
                        <div class="tooltip-row">
                          <div class="tooltip-icon">
                            <i class="pi pi-clock"></i>
                          </div>
                          <div class="tooltip-info">
                            <span class="label">Time</span>
                            <span class="value">{{
                              task.completedAt | date: "shortTime"
                              }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </div>
              </td>

              <!-- Status -->
              <td>
                <span class="status-badge" [ngClass]="getStatusClass(getStatusLabel(task.statusId))"
                  [style.backgroundColor]="getStatusColor(task.statusId) + '15'"
                  [style.color]="getStatusColor(task.statusId)">
                  <span class="dot" [style.backgroundColor]="getStatusColor(task.statusId)"></span>
                  {{ getStatusLabel(task.statusId) }}
                </span>
              </td>

              <!-- Priority -->
              <td>
                <span class="priority-tag" [ngClass]="getPriorityClass(task.priority)">
                  {{ task.priority || "Normal" }}
                </span>
              </td>

              <!-- Task Group -->
              <td>
                <span class="task-group-badge">
                  {{
                  task.taskGroupId?.groupName ||
                  task.taskGroupId?.name ||
                  "N/A"
                  }}
                </span>
              </td>

              <!-- Progress -->
              <td>
                <div class="progress-wrapper">
                  <div class="progress-bar-bg">
                    <div class="progress-bar-fill" [ngClass]="
                        getProgressColorClass(task.progressPercentage || 0)
                      " [style.width.%]="task.progressPercentage || 0"></div>
                  </div>
                  <span class="progress-text">{{ task.progressPercentage || 0 }}%</span>
                </div>
              </td>

              <!-- Assignees -->
              <td>
                <div class="avatars-group">
                  <ng-container *ngIf="task.assignedTo?.length > 0; else noAssignee">
                    <ng-container *ngFor="
                        let user of task.assignedTo.slice(0, 3);
                        let i = index
                      ">
                      <img [src]="getProfileImage(user)" (error)="
                          onImgError(
                            $event,
                            generateAvatar(user?.fullName || 'User')
                          )
                        " [alt]="user.fullName" [title]="user.fullName" class="avatar-circle"
                        [style.zIndex]="10 - i" />
                    </ng-container>
                    <div *ngIf="task.assignedTo.length > 3" class="avatar-more">
                      +{{ task.assignedTo.length - 3 }}
                    </div>
                  </ng-container>
                  <ng-template #noAssignee>
                    <span class="text-xs text-muted fst-italic">Unassigned</span>
                  </ng-template>
                </div>
              </td>

              <!-- Completed Date -->
              <td>
                <div class="date-display">
                  <span class="day">{{ task.completedAt | date: "d" }}</span>
                  <span class="month">{{
                    task.completedAt | date: "MMM"
                    }}</span>
                </div>
              </td>
            </tr>

            <!-- Subtask Row -->
            <tr *ngIf="expandedTaskId === task._id" class="subtask-row-container">
              <td colspan="7" class="p-0 border-0">
                <div class="subtasks-wrapper">
                  <div *ngIf="
                      !subtaskMap[task._id] || subtaskMap[task._id].length === 0
                    " class="empty-subtasks">
                    <span *ngIf="!subtaskMap[task._id]"><i class="pi pi-spin pi-spinner me-2"></i>Loading...</span>
                    <span *ngIf="subtaskMap[task._id]?.length === 0">No subtasks found.</span>
                  </div>

                  <table *ngIf="
                      subtaskMap[task._id] && subtaskMap[task._id].length > 0
                    " class="table table-sm subtasks-table">
                    <tbody>
                      <tr *ngFor="let sub of subtaskMap[task._id]; let isLast = last" class="subtask-row"
                        [class.is-last-subtask]="isLast">
                        <td style="width: 30%">
                          <div class="d-flex align-items-center">
                            <span class="subtask-indicator" [class.is-last]="isLast"></span>
                            <span class="completion-checkbox small" [ngClass]="{
                                completed: sub.userCompletedTask === 'yes',
                              }" (click)="toggleCompletion(sub, $event)" [pTooltip]="
                                sub.userCompletedTask === 'yes'
                                  ? 'Click to unmark'
                                  : 'Click to complete'
                              " tooltipPosition="top" appendTo="body">
                              <i class="pi pi-check" *ngIf="sub.userCompletedTask === 'yes'"></i>
                            </span>
                            <span class="ms-2 task-title" [ngClass]="{
                                'text-decoration-line-through text-muted':
                                  sub.userCompletedTask === 'yes',
                              }" [pTooltip]="subtaskTooltip" tooltipPosition="top" [escape]="false"
                              tooltipStyleClass="custom-task-tooltip" appendTo="body">
                              {{ sub.title }}
                            </span>

                            <ng-template #subtaskTooltip>
                              <div class="task-tooltip-container">
                                <div class="tooltip-header">
                                  <i class="pi pi-check-circle me-2"></i>
                                  Subtask Completed
                                </div>
                                <div class="tooltip-body">
                                  <div class="tooltip-row">
                                    <div class="tooltip-icon">
                                      <i class="pi pi-plus-circle"></i>
                                    </div>
                                    <div class="tooltip-info">
                                      <span class="label">Created By</span>
                                      <span class="value">{{
                                        sub.createdBy?.firstName ||
                                        sub.createdBy?.userName ||
                                        "System"
                                        }}
                                        {{
                                        sub.createdBy?.lastName || ""
                                        }}</span>
                                    </div>
                                  </div>
                                  <div class="tooltip-row">
                                    <div class="tooltip-icon">
                                      <i class="pi pi-user"></i>
                                    </div>
                                    <div class="tooltip-info">
                                      <span class="label">Completed By</span>
                                      <span class="value">{{
                                        sub.completedBy?.userId?.firstName ||
                                        sub.completedBy?.userName ||
                                        "User"
                                        }}
                                        {{
                                        sub.completedBy?.userId?.lastName ||
                                        ""
                                        }}</span>
                                    </div>
                                  </div>
                                  <div class="tooltip-row" *ngIf="sub.completedAt">
                                    <div class="tooltip-icon">
                                      <i class="pi pi-calendar"></i>
                                    </div>
                                    <div class="tooltip-info">
                                      <span class="label">Date</span>
                                      <span class="value">{{
                                        sub.completedAt | date: "mediumDate"
                                        }}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </ng-template>
                          </div>
                        </td>
                        <td style="width: 10%">
                          <span class="status-badge small" [style.backgroundColor]="
                              getStatusColor(sub.statusId) + '15'
                            " [style.color]="getStatusColor(sub.statusId)">
                            {{ getStatusLabel(sub.statusId) }}
                          </span>
                        </td>
                        <td style="width: 10%">
                          <span class="priority-tag small" [ngClass]="getPriorityClass(sub.priority)">
                            {{ sub.priority || "Normal" }}
                          </span>
                        </td>
                        <!-- Task Group for Subtask -->
                        <td style="width: 12%">
                          <!-- Usually subtasks inherit task group or don't have one specifically, or can't be set separately.
                                                         If `sub.taskGroupId` exists, use it. If not, maybe use parent?
                                                         Usually subtasks belong to the parent task which belongs to a group.
                                                         So we can check `sub.taskGroupId` first. -->
                          <span class="task-group-badge small">
                            {{
                            sub.taskGroupId?.groupName ||
                            sub.taskGroupId?.name ||
                            "N/A"
                            }}
                          </span>
                        </td>
                        <td style="width: 13%">
                          <div class="progress-wrapper small">
                            <div class="progress-bar-bg">
                              <div class="progress-bar-fill" [ngClass]="
                                  getProgressColorClass(
                                    sub.progressPercentage || 0
                                  )
                                " [style.width.%]="sub.progressPercentage || 0"></div>
                            </div>
                          </div>
                        </td>
                        <td style="width: 15%">
                          <div class="avatars-group small">
                            <ng-container *ngFor="
                                let user of (sub.assignedTo || []).slice(0, 3);
                                let i = index
                              ">
                              <img [src]="getProfileImage(user)" class="avatar-circle" [title]="user.fullName"
                                [style.zIndex]="10 - i" />
                            </ng-container>
                          </div>
                        </td>
                        <td style="width: 10%">
                          <span class="text-muted text-xs">{{
                            sub.dueDate ? (sub.dueDate | date: "dd MMM") : "-"
                            }}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>
          </ng-container>

          <!-- Empty State handled outside table -->
        </tbody>
      </table>
      <div *ngIf="loading" class="text-center py-4">
        <i class="pi pi-spin pi-spinner text-primary" style="font-size: 1.5rem"></i>
        <span class="ms-2 text-primary">Loading tasks...</span>
      </div>
    </div>
  </div>
  </ng-container>
</div>